import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Innovation: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m479.5 580h-30v-61.71c.1-22.6 10.64-43.42 28.92-57.17 47.49-36.18 91.49-78.39 91.54-141.26-2.5-95.98-85.15-172.14-184.31-169.81-97.4 2.18-176.18 80.79-175.64 175.24 0 30.42 8.92 55.89 28.09 80.26 17.8 22.62 42.24 41.15 63.8 57.5 18.42 13.91 28.58 33.53 28.61 55.23v61.72h-30v-61.71c-.02-15.46-9.1-25.57-16.71-31.32-46.25-35.07-103.79-78.69-103.79-161.6-.63-110.63 91.31-202.77 204.96-205.31 56-1.31 109.16 18.63 149.75 56.16 40.71 37.64 63.88 88.46 65.25 143.08v.36c.05 76.24-52.26 126.39-103.43 165.38-10.79 8.12-16.97 20.24-17.03 33.32v61.64z' />
    <path d='m525 310h-30c0-17.56-8.98-36.52-24.65-52-21.08-20.84-50.28-32.6-80.18-32.24l-.35-30c37.82-.44 74.87 14.47 101.62 40.91 21.64 21.39 33.56 47.43 33.56 73.34z' />
    <path d='m480 660h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m300 570h180v30h-180z' />
  </IconBase>
));

Innovation.displayName = 'Innovation';

export default Innovation;
